import { UnitsEnum } from '../../../../../services/entities/impl/blfApi/apiConstants';

export const DEFAULT_UNIFORMITY_FILTER = {
  minSize: 0,
  maxSize: 0,
  clusterConsistency: 0,
} as const;

export const clusterConsistencyOptions = [
  { value: 0, label: 'None' },
  { value: 50, label: '50%+' },
  { value: 55, label: '55%+' },
  { value: 60, label: '60%+' },
  { value: 65, label: '65%+' },
  { value: 70, label: '70%+' },
  { value: 75, label: '75%+' },
  { value: 80, label: '80%+' },
  { value: 85, label: '85%+' },
  { value: 90, label: '90%+' },
  { value: 95, label: '95%+' },
  { value: 100, label: '100%' },
];

/**
 * Static mapping of berry sizes with metric and imperial labels.
 * Note: Values are always stored in metric (mm), only the labels change based on unit system.
 */
const berrySizeMapping = [
  { value: 5, metricLabel: '5mm', imperialLabel: '3/16"' },
  { value: 10, metricLabel: '10mm', imperialLabel: '6/16"' },
  { value: 15, metricLabel: '15mm', imperialLabel: '9/16"' },
  { value: 20, metricLabel: '20mm', imperialLabel: '13/16"' },
  { value: 25, metricLabel: '25mm', imperialLabel: '16/16"' },
  { value: 30, metricLabel: '30mm', imperialLabel: '19/16"' },
  { value: 35, metricLabel: '35mm', imperialLabel: '22/16"' },
];

/**
 * Returns berry size options with labels formatted according to the specified unit system
 * @param unitSystem - UnitsEnum value for determining label format
 * @returns array of berry size options with appropriate labels
 */
export const getBerrySizeOptions = (unitSystem: UnitsEnum) => {
  return berrySizeMapping.map(({ value, metricLabel, imperialLabel }) => ({
    value,
    label: unitSystem === UnitsEnum.imperial ? imperialLabel : metricLabel,
  }));
};

/**
 * Helper function to get the appropriate label for a given metric value and unit system
 * @param mm - the metric value in millimeters
 * @param unitSystem - UnitsEnum value for determining label format
 * @returns the appropriate label for the given value and unit system
 */
export const getBerrySizeLabel = (
  mm: number,
  unitSystem: UnitsEnum
): string => {
  const mapping = berrySizeMapping.find((item) => item.value === mm);
  if (!mapping) {
    return `${mm}mm`; // fallback to metric if not found in mapping
  }
  return unitSystem === UnitsEnum.imperial
    ? mapping.imperialLabel
    : mapping.metricLabel;
};

// Keep the original berrySizeOptions for backward compatibility
export const berrySizeOptions = getBerrySizeOptions(UnitsEnum.metric);
